import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import "./ProductInfo.css";

const ProductInfo = () => {
  return (
    <>
      <Box
        sx={{
          width: { md: 9 / 10, sm: 1 },
          ml: "auto",
          mr: "auto",
          mb: 10,
          mt: 5,
        }}
      >
        <Box
          sx={{
            textAlign: "left",
            pl: 6,
            pr: 6,
            fontSize: "17px",
            color: "#424242",
          }}
        >
          상품정보 제공고시
          {/* <Box
        sx={{
          borderBottom: "5px solid #f3756d",
          width: "40px",
          paddingBottom: "20px",
        }}
      ></Box> */}
        </Box>
        <Box
          sx={{
            mx: 6,
            mt: 4,
            width: 1,
            borderTop: "1px solid lightgray",
            borderBottom: "1px solid lightgray",
          }}
        >
          <Grid container>
            <Grid
              item
              md={2}
              sx={{
                minHeight: "200px",
                display: "flex",
                alignItems: "center",
                backgroundColor: "#fafafa",
                px: 4,
                justifyContent: "center",
                lineHeight: "200%",
              }}
            >
              생활화학제품에 관한 법률에 따른 표시사항
            </Grid>
            <Grid
              item
              md={10}
              sx={{
                minHeight: "200px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                px: 2,
                fontSize: "11px",
                color: "#7e7e7e",
                py: 2,
              }}
            >
              <ul>
                <li className="left">품목 및 제품명:</li>
                <li className="right">다목적세정살균티슈(PERFECT ALL CLEAN)</li>
              </ul>
              <ul>
                <li className="left">용도 및 제형:</li>
                <li className="right">세정살균제/분무기용</li>
              </ul>
              <ul>
                <li className="left">제조연월:</li>
                <li className="right">2022.04</li>
              </ul>
              <ul>
                <li className="left">유통기한:</li>
                <li className="right">2024.04</li>
              </ul>
              <ul>
                <li className="left">중량•용량•매수:</li>
                <li className="right">500ml</li>
              </ul>
              <ul>
                <li className="left">효과•효능:</li>
                <li className="right">알코올FREE.99.9%살균.7일항균지속</li>
              </ul>
              <ul>
                <li className="left">제조국:</li>
                <li className="right">대한민국</li>
              </ul>
              <ul>
                <li className="left">제조자(사):</li>
                <li className="right">헤즐릿</li>
              </ul>
              <ul>
                <li className="left">어린이 보호포장 대상 제품유무</li>
                <li className="right">해당없음</li>
              </ul>
              <ul>
                <li className="left">제품에 사용된 화학물질 명칭</li>
                <li className="right">
                  메톡시프로판올.소듐라우레스설페이트(음이온계),부틸셀로솔브,폴리옥시에틸렌솔비탄모노오레일레이트(음이온계),황상아연,구연산,정제수
                </li>
              </ul>
              <ul>
                <li className="left">사용상 주의사항</li>
                <li className="right">사용설명서참조</li>
              </ul>
              <ul>
                <li className="left">
                  안전기준 적합확인 신고번호(자가검사번호) 또는 안전확인대상
                  생활화학제품 승인번호
                </li>
                <li className="right">신고번호 제 CB22-01-0275호</li>
              </ul>
            </Grid>
          </Grid>
          <Grid container>
            <Grid
              item
              md={2}
              sx={{
                minHeight: "100px",
                display: "flex",
                alignItems: "center",
                backgroundColor: "#fafafa",
                px: 4,
                justifyContent: "center",
                lineHeight: "200%",
              }}
            >
              소비자 상담 관련 전화번호
            </Grid>
            <Grid
              item
              md={10}
              sx={{
                minHeight: "100px",
                display: "flex",
                flexDirection: "column",
                px: 5,
                fontSize: "11px",
                color: "#7e7e7e",
                py: 2,
              }}
            >
              070-7777-4524
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box
        sx={{
          width: { md: 9 / 10, sm: 1 },
          ml: "auto",
          mr: "auto",
          mb: 10,
          mt: 5,
        }}
      >
        <Box
          sx={{
            textAlign: "left",
            pl: 6,
            pr: 6,
            fontSize: "17px",
            color: "#424242",
          }}
        >
          거래조건에 관한 정보
          {/* <Box
          sx={{
            borderBottom: "5px solid #f3756d",
            width: "40px",
            paddingBottom: "20px",
          }}
        ></Box> */}
        </Box>
        <Box
          sx={{
            mx: 6,
            mt: 4,
            width: 1,
            borderTop: "1px solid lightgray",
            borderBottom: "1px solid lightgray",
            lineHeight: "180%",
          }}
        >
          <Grid container>
            <Grid
              item
              md={4}
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#fafafa",
                px: 4,
              }}
            >
              재화등의 배송방법에 관한 정보
            </Grid>
            <Grid
              item
              md={8}
              sx={{
                display: "flex",
                flexDirection: "column",
                px: 2,
                fontSize: "11px",
                color: "#7e7e7e",
                py: 2,
              }}
            >
              택배
            </Grid>
            <Grid
              item
              md={4}
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#fafafa",
                px: 4,
                borderTop: "1px solid lightgray",
              }}
            >
              주문 이후 예상되는 배송기간
            </Grid>
            <Grid
              item
              md={8}
              sx={{
                display: "flex",
                flexDirection: "column",
                px: 2,
                fontSize: "11px",
                color: "#7e7e7e",
                py: 2,
                borderTop: "1px solid lightgray",
              }}
            >
              대금 지급일로부터 3일 이내에 발송
            </Grid>
            <Grid
              item
              md={4}
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#fafafa",
                px: 4,
                borderTop: "1px solid lightgray",
              }}
            >
              제품하자·오배송 등에 따른 청약철회 등의 경우 청약철회 등을 할 수
              있는 기간 및 통신판매업자가 부담하는 반품비용 등에 관한 정보
            </Grid>
            <Grid
              item
              md={8}
              sx={{
                display: "flex",
                flexDirection: "column",
                px: 2,
                fontSize: "11px",
                color: "#7e7e7e",
                py: 2,
                borderTop: "1px solid lightgray",
              }}
            >
              전자상거래등에서의소비자보호에관한법률 등에 의한 제품의 하자 또는
              오배송 등으로 인한 청약철회의 경우에는 상품 수령 후 3개월 이내, 그
              사실을 안 날 또는 알 수 있었던 날로부터 30일 이내에 청약철회를 할
              수 있으며, 반품 비용은 통신판매업자가 부담합니다.
            </Grid>
            <Grid
              item
              md={4}
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#fafafa",
                px: 4,
                borderTop: "1px solid lightgray",
              }}
            >
              제품하자가 아닌 소비자의 단순변심, 착오구매에 따른 청약철회 시
              소비자가 부담하는 반품비용 등에 관한 정보
            </Grid>
            <Grid
              item
              md={8}
              sx={{
                display: "flex",
                flexDirection: "column",
                px: 2,
                fontSize: "11px",
                color: "#7e7e7e",
                py: 2,
                borderTop: "1px solid lightgray",
              }}
            >
              편도 3000원 (최초 배송비 무료인 경우 6000원 부과)
            </Grid>
            <Grid
              item
              md={4}
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#fafafa",
                px: 4,
                borderTop: "1px solid lightgray",
              }}
            >
              제품하자가 아닌 소비자의 단순변심, 착오구매에 따른 청약철회가
              불가능한 경우 그 구체적 사유와 근거
            </Grid>
            <Grid
              item
              md={8}
              sx={{
                display: "flex",
                flexDirection: "column",
                px: 2,
                fontSize: "11px",
                color: "#7e7e7e",
                py: 2,
                borderTop: "1px solid lightgray",
              }}
            >
              전자상거래등에서의소비자보호에관한법률 등에 의한 청약철회 제한
              사유에 해당하는 경우 및 기타 객관적으로 이에 준하는 것으로
              인정되는 경우 청약철회가 제한될 수 있습니다.
            </Grid>
            <Grid
              item
              md={4}
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#fafafa",
                px: 4,
                borderTop: "1px solid lightgray",
              }}
            >
              재화등의 교환·반품·보증 조건 및 품질보증기준
            </Grid>
            <Grid
              item
              md={8}
              sx={{
                display: "flex",
                flexDirection: "column",
                px: 2,
                fontSize: "11px",
                color: "#7e7e7e",
                py: 2,
                borderTop: "1px solid lightgray",
              }}
            >
              소비자분쟁해결기준(공정거래위원회 고시) 및 관계법령에 따릅니다.
            </Grid>
            <Grid
              item
              md={4}
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#fafafa",
                px: 4,
                borderTop: "1px solid lightgray",
              }}
            >
              재화등의 A/S 관련 전화번호
            </Grid>
            <Grid
              item
              md={8}
              sx={{
                display: "flex",
                flexDirection: "column",
                px: 2,
                fontSize: "11px",
                color: "#7e7e7e",
                py: 2,
                borderTop: "1px solid lightgray",
              }}
            >
              070-7777-4524
            </Grid>
            <Grid
              item
              md={4}
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#fafafa",
                px: 4,
                borderTop: "1px solid lightgray",
              }}
            >
              대금을 환불받기 위한 방법과 환불이 지연될 경우 지연에 따른
              배상금을 지급받을 수 있다는 사실 및 배상금 지급의 구체적 조건 및
              절차
            </Grid>
            <Grid
              item
              md={8}
              sx={{
                display: "flex",
                flexDirection: "column",
                px: 2,
                fontSize: "11px",
                color: "#7e7e7e",
                py: 2,
                borderTop: "1px solid lightgray",
              }}
            >
              주문취소 및 대금의 환불은 네이버 페이 마이페이지에서 신청할 수
              있으며, 전자상거래 등에서의 소비자보호에 관한 법률에 따라 소비자의
              청약철회 후 판매자가 재화 등을 반환 받은 날로부터 3영업일 이내에
              지급받은 대금의 환급을 정당한 사유 없이 지연하는 때에는 소비자는
              지연기간에 대해서 연 15%의 지연배상금을 판매자에게 청구할 수
              있습니다.
            </Grid>
            <Grid
              item
              md={4}
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#fafafa",
                px: 4,
                borderTop: "1px solid lightgray",
              }}
            >
              소비자피해보상의 처리, 재화등에 대한 불만 처리 및 소비자와 사업자
              사이의 분쟁처리에 관한 사항
            </Grid>
            <Grid
              item
              md={8}
              sx={{
                display: "flex",
                flexDirection: "column",
                px: 2,
                fontSize: "11px",
                color: "#7e7e7e",
                py: 2,
                borderTop: "1px solid lightgray",
              }}
            >
              소비자분쟁해결기준(공정거래위원회 고시) 및 관계법령에 따릅니다.
            </Grid>
            <Grid
              item
              md={4}
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#fafafa",
                px: 4,
                borderTop: "1px solid lightgray",
              }}
            >
              거래에 관한 약관의 내용 또는 확인할 수 있는 방법
            </Grid>
            <Grid
              item
              md={8}
              sx={{
                display: "flex",
                flexDirection: "column",
                px: 2,
                fontSize: "11px",
                color: "#7e7e7e",
                py: 2,
                borderTop: "1px solid lightgray",
              }}
            >
              상품상세 페이지 및 페이지 하단의 이용약관 링크를 통해 확인할 수
              있습니다.
            </Grid>
          </Grid>
        </Box>
      </Box>

      <Box
        sx={{
          width: { md: 9 / 10, sm: 1 },
          ml: "auto",
          mr: "auto",
          mb: 10,
          mt: 5,
        }}
      >
        <Box
          sx={{
            textAlign: "left",
            pl: 6,
            pr: 6,
            fontSize: "17px",
            color: "#424242",
          }}
        >
          헤즐릿 반품/교환 정보
          {/* <Box
          sx={{
            borderBottom: "5px solid #f3756d",
            width: "40px",
            paddingBottom: "20px",
          }}
        ></Box> */}
        </Box>
        <Box
          sx={{
            mx: 6,
            mt: 4,
            width: 1,
            borderTop: "1px solid lightgray",
            borderBottom: "1px solid lightgray",
            lineHeight: "180%",
          }}
        >
          <Grid container>
            <Grid
              item
              md={4}
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#fafafa",
                px: 4,
              }}
            >
              판매자 지정택배사
            </Grid>
            <Grid
              item
              md={8}
              sx={{
                display: "flex",
                flexDirection: "column",
                px: 2,
                fontSize: "11px",
                color: "#7e7e7e",
                py: 2,
              }}
            >
              우체국 택배
            </Grid>
            <Grid
              item
              md={4}
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#fafafa",
                px: 4,
                borderTop: "1px solid lightgray",
              }}
            >
              반품 배송비
            </Grid>
            <Grid
              item
              md={8}
              sx={{
                display: "flex",
                flexDirection: "column",
                px: 2,
                fontSize: "11px",
                color: "#7e7e7e",
                py: 2,
                borderTop: "1px solid lightgray",
              }}
            >
              편도 3,000원 (최초 배송비 무료인 경우 6.000원 부과)
            </Grid>
            <Grid
              item
              md={4}
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#fafafa",
                px: 4,
                borderTop: "1px solid lightgray",
              }}
            >
              보내실 곳
            </Grid>
            <Grid
              item
              md={8}
              sx={{
                display: "flex",
                flexDirection: "column",
                px: 2,
                fontSize: "11px",
                color: "#7e7e7e",
                py: 2,
                borderTop: "1px solid lightgray",
              }}
            >
              서울특별시 강서구 공항대로 190 (푸리마타워) 1316호 (우: 07631)
            </Grid>
            <Grid
              item
              md={4}
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#fafafa",
                px: 4,
                borderTop: "1px solid lightgray",
              }}
            >
              반품/교화 사유에 따른 요청 가능 기간
            </Grid>
            <Grid
              item
              md={8}
              sx={{
                display: "flex",
                flexDirection: "column",
                px: 2,
                fontSize: "11px",
                color: "#7e7e7e",
                py: 2,
                borderTop: "1px solid lightgray",
              }}
            >
              구매자 단순 변심은 상품 수령 후 7일 이내 (구매자 반품배송비 부담)
              <br />
              표시/광고와 상이, 계약 내용과 다르게 이행된 경우 상품 수령 후
              3개월 이내 혹은 표시/광고와 다른 사실을 안 날로부터 30일 이내
              (판매자 반품 배송비 부담) <br />
              둘중 하나 경과시 반품/교환 불가
            </Grid>
            <Grid
              item
              md={4}
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#fafafa",
                px: 4,
                borderTop: "1px solid lightgray",
              }}
            >
              반품/교환 불가능 사유
            </Grid>
            <Grid
              item
              md={8}
              sx={{
                display: "flex",
                flexDirection: "column",
                px: 2,
                fontSize: "11px",
                color: "#7e7e7e",
                py: 2,
                borderTop: "1px solid lightgray",
              }}
            >
              1. 반품요철기간이 지난 경우
              <br />
              2. 구매자의 책임 있는 사유로 상품 등이 멸실 또는 훼손된 경우 (단,
              상품의 내용을 확인하기 위하여 포장 등을 훼손한 경우는 제외)
              <br />
              3. 구매자의 책임있는 사유로 포장이 훼손되어 상품 가치가 현저히
              상실된 경우
              <br />
              4. 구매자의 사용 또는 일부 소비에 의하여 상품의 가치가 현저히
              감소한 경우
              <br />
              5. 시간의 경과에 의하여 재판매가 곤란할 정도로 상품의 가치가
              현저히 감소한 경우
              <br />
              6. 고객의 요청사항에 맞춰 제작에 들어가는 맞춤제작상품의 경우
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default ProductInfo;
